import { render, staticRenderFns } from "./AddPostalCode.vue?vue&type=template&id=17006d74&scoped=true&"
import script from "./AddPostalCode.vue?vue&type=script&lang=js&"
export * from "./AddPostalCode.vue?vue&type=script&lang=js&"
import style0 from "./AddPostalCode.vue?vue&type=style&index=0&id=17006d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17006d74",
  null
  
)

export default component.exports